module.exports = __webpack_public_path__ + "static/media/FeedTime_web_1_preview.0090d61a.jpg";